/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPeopleGroupBody = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 10a3 3 0 0 1 3 3v9H9v-9a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v7h2v-7a1 1 0 0 0-1-1zm-7 0a3 3 0 0 1 3 3v6H2v-6a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v4h2v-4a1 1 0 0 0-1-1zm14-2a3 3 0 0 1 3 3v6h-6v-6a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v4h2v-4a1 1 0 0 0-1-1zM5 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm14-2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-7-4a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPeopleGroupBody as PeopleGroupBody };
